import React, { useState, useEffect } from "react";
import Header from "../../components/Header/header";
import PlanningWes1 from "./PlanningWes/PlanningWes1";
import Footer from "../../components/Footer/Footer";
import "./Planning.css";
import { Col, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { confirmToast } from "../../components/ConfirmToast/ConfirmToast";
import {
  formatGermanFixedBy2,
  formatGermanInputForDecimal,
} from "../../utility/NumberFormat";
import PlanningTableNew from "./planningTable/PlanningTableNew";
import { createDispatchHook, useDispatch, useSelector } from "react-redux";
import {
  calculateHDPFromPARTP,
  calculateHDP,
  calculatePARTP,
  calculateDTPRow,
} from "../VkPlanning/PlanningCalculations";
import ReleaseTime from "./ReleaseTime";
import {
  setSelectedCustomerDetail,
  clearSelectedCustomerDetail,
} from "../../slices/customerSlice";
// import { formatGermanInput } from "../../utility/NumberFormat";

const Planning = () => {
  const { customerID, year, div, shipTo, city, customerName, vtr, isEditable } =
    useParams();

  const selectedCustomer = useSelector((state) => {
    const c = state.customer.selectedCustomerDetail;
    if (!c) return c;

    return {
      ...c,
      isEditable:
        isEditable === "J" || c.isEditable === "" || c.isEditable === "J",
    };
  });

  const norm = (v) => (v === "blank" ? "" : v);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const safeShipTo = norm(selectedCustomer?.shipTo);
  const safeCity = norm(selectedCustomer?.cty);
  const safeCustomerName = norm(selectedCustomer?.name);

  // console.log("Corrected VK:", fixedVK, "Length:", fixedVK.length);
  const authToken = localStorage.getItem("authToken");
  const [selectedYear, setSelectedYear] = useState(
    year || selectedCustomer?.year || ""
  );
  // console.log("selectedYear",selectedYear.length)
  const [selectedHandler, setSelectedHandler] = useState(
    div || selectedCustomer?.div || ""
  );
  const [uniqTemplates, setUniqTemplates] = useState([]);
  // const [allCustomers, setAllCustomers] = useState([]);
  const [copyTemplate, setCopyTemplate] = useState({});
  // console.log("copyTemplate", copyTemplate)

  const [newTemplateFor, setNewtemplateFor] = useState(
    customerID || selectedCustomer?.soldTo || ""
  );
  const [selectedKey, setSelectedKey] = useState(() => {
    if (customerID || selectedCustomer?.soldTo) {
      return `${selectedCustomer?.soldTo}|${safeShipTo}`;
    }
    return null; // IMPORTANT for react-select
  });

  const [newTemplateForAll, setNewtemplateForAll] = useState({
    soldTo: selectedCustomer?.soldTo || "",
    shipTo: safeShipTo || "",
    year: selectedCustomer?.year || "",
    div: selectedCustomer?.div || "",
    city: safeCity || "",
    name: safeCustomerName || "",
    vtr: selectedCustomer?.vtr || "",
    address1: norm(selectedCustomer?.ad1) || "",
  });

  const [singleApiData, setSingleApiData] = useState({});
  const [resetFlag, setResetFlag] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [exitAndSaveLoading, setExitAndSaveLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [getValue, setGetValue] = useState({
    jahresVK: "",
    jahresEK: "",
  });
  const [vkPlanningAllInOneNew, setVkPlanningAllInOneNew] = useState({
    HDP: { subJahresVK: 0 },
    // WP: {},
    DTP: [],
    PARTP: [{ typId: "KOLL" }, { typId: "NOS" }],
  });
  // const [vkPlanning_data_for_compare, setVkPlanning_data_for_compare] = useState({});
  const [vkPlanning_data_for_compare, setVkPlanning_data_for_compare] =
    useState(false);
  // console.log("vkPlanning_data_for_compare", vkPlanning_data_for_compare)
  const [vkPlanningLoaded, setVkPlanningLoaded] = useState(false);
  const [planningLock, setPlanningLock] = useState(null);

  const [soldToDecision, setSoldToDecision] = useState("zeroAndNewEntry");
  const [showSoldToDecisionModal, setShowSoldToDecisionModal] = useState(false);

  useEffect(() => {
    if (selectedCustomer?.soldTo && selectedCustomer?.isLockPlanning === true) {
      // console.log("is this running?", selectedCustomer?.isLockPlanning);
      navigate(
        `/vk-planning/${selectedCustomer.soldTo || "blank"}/${
          selectedCustomer.shipTo || "blank"
        }/${selectedCustomer.year || "blank"}/${
          selectedCustomer.div || "blank"
        }/${encodeURIComponent(
          selectedCustomer.cty || "blank"
        )}/${encodeURIComponent(selectedCustomer.name || "blank")}/${
          selectedCustomer.vtr || "blank"
        }/${selectedCustomer.isEditable || "blank"}`,
        { replace: true }
      );

      return;
    } else {
      toast.error(
        "You can't go directly to VK Planning. Please select a customer first."
      );

      navigate("/customer-summary", { replace: true });
      return;
    }
  }, []);

  useEffect(() => {
    const isOldSoldToZero = selectedCustomer?.newSoldTo !== "";

    if (isOldSoldToZero) {
      console.log("here we are???");
      setSoldToDecision("zeroAndNewEntry"); // reset on fresh entry
      setShowSoldToDecisionModal(true);
    }
  }, []);

  const getFunction = (e) => {
    const { name, value } = e.target;

    // copy template
    if (name === "copyTemplate") {
      const selectedObj = uniqTemplates?.find((item) => item.soldTo === value);

      // manual change bhi ho jayega
      setCopyTemplate(selectedObj || {});
    } else if (name === "newTemplate") {
      setNewtemplateFor(value);
    }
  };

  //  copy Template APi code
  const handleTemplateChange = async (year) => {
    try {
      let url = `${process.env.REACT_APP_API_LINK}/api/v1/entry/getUniqTempSoldTo`;

      if (year) {
        url += `?year=${year}`;
      }

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      // console.log("uniq sold to template?", response.data);
      setUniqTemplates(response.data.data);
      //IMPORTANT: previous selected template clear
      setCopyTemplate("");
    } catch (error) {
      console.error("Error fetching templates:", error);
    }
  };

  useEffect(() => {
    // if (selectedYear) {
    handleTemplateChange(selectedYear);
    // }
  }, [selectedYear]);

  const mapApiToState = (data) => {
    return {
      HDP: data?.hdr || {},
      DTP: data?.dtl ? data.dtl : [],
      // WP: data?.wes || {},
      PARTP: data?.partP || [],
    };
  };

  useEffect(() => {
    if (
      vkPlanningLoaded &&
      copyTemplate?.soldTo
      // &&
      // !vkPlanningAllInOneNew?.isJahresVkExist
    ) {
      singleIdDataALL();
    }
  }, [
    vkPlanningLoaded,
    copyTemplate?.soldTo,
    vkPlanningAllInOneNew?.isJahresVkExist,
    vkPlanningAllInOneNew?.isJahresEkExist,
  ]);

  const singleIdDataALL = async () => {
    const soldTo = copyTemplate?.soldTo;
    if (!soldTo) {
      return;
    }

    // if(vkPlanningAllInOneNew?.HDP?.isJahresVkExist === true || vkPlanningAllInOneNew?.HDP?.isJahresVkExist === true) return;

    const api = `${process.env.REACT_APP_API_LINK}/api/v1/entry/getTemplateDataBySoldTo?soldTo=${soldTo}&division=${copyTemplate?.division}&year=${copyTemplate?.planYear}`;
    try {
      const res = await axios.get(api, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      // console.log("res data?", res.data);
      setSingleApiData(res.data.data);

      // setVkPlanningAllInOneNew((prev) => {
      //   const mapped = mapApiToState(res.data.data);

      //   // console.log("mapped?", mapped);

      //   const mergedHDP = {
      //     ...prev.HDP,
      //     ...mapped.HDP,

      //     createdAt: prev?.HDP?.createdAt,
      //     updatedAt: prev?.HDP?.updatedAt,
      //   };

      //   const updatedHDP = calculateHDP(mergedHDP, mapped);

      //   // const updatedWP = {
      //   //   ...prev.WP,
      //   //   ...mapped.WP,

      //   //   createdAt: prev?.WP?.createdAt,
      //   //   updatedAt: prev?.WP?.updatedAt,
      //   // };

      //   const tempState = {
      //     ...prev,
      //     HDP: updatedHDP,
      //   };

      //   // const newWP = calculateWP(updatedWP, tempState);

      //   const mergedPARTP =
      //     mapped.PARTP?.length > 0
      //       ? mapped.PARTP.map((row, index) => ({
      //           ...prev.PARTP?.[index],
      //           ...row,
      //         }))
      //       : prev.PARTP;

      //   const newPARTP = calculatePARTP(mergedPARTP, tempState);

      //   const mergedDTP =
      //     mapped.DTP?.length > 0
      //       ? mapped.DTP.map((row, index) => ({
      //           ...prev.DTP?.[index],
      //           ...row,
      //         }))
      //       : prev.DTP;

      //   const newDTP = mergedDTP.map((row) =>
      //     calculateDTPRow(row, tempState, newPARTP),
      //   );

      //   return {
      //     ...prev,

      //     HDP: updatedHDP,
      //     PARTP: newPARTP,
      //     DTP: newDTP,

      //     isJahresVkExist: prev.isJahresVkExist,
      //     isJahresEkExist: prev.isJahresEkExist,

      //     discountPercent: prev?.discountPercent,
      //     ssqr: prev?.ssqr,
      //   };
      // });

      setVkPlanningAllInOneNew((prev) => {
        const mapped = mapApiToState(res.data.data);

        // 1. Merge HDP
        const mergedHDP = {
          ...prev.HDP,
          ...mapped.HDP,

          createdAt: prev?.HDP?.createdAt,
          updatedAt: prev?.HDP?.updatedAt,
        };

        // 2. Merge PARTP
        const mergedPARTP =
          mapped.PARTP?.length > 0
            ? mapped.PARTP.map((row, index) => ({
                ...prev.PARTP?.[index],
                ...row,
              }))
            : prev.PARTP || [];

        /*
         * Calculate HDP using API jahresVK.
         * This calculates jahresEK.
         */
        const firstState = {
          ...prev,
          HDP: mergedHDP,
          PARTP: mergedPARTP,
        };

        const firstHDP = calculateHDP(mergedHDP, firstState);

        /*
         * SECOND STEP
         *
         * Now jahresEK exists, so PARTP can calculate:
         */
        const newPARTP = calculatePARTP(mergedPARTP, {
          ...firstState,
          HDP: firstHDP,
        });

        /*
         * SECOND HDP PASS
         * - bestandAvg
         * - lugPlan
         */
        const finalHDP = calculateHDP(firstHDP, {
          ...firstState,
          HDP: firstHDP,
          PARTP: newPARTP,
        });

        /*
         * DTP calculation
         */
        const mergedDTP =
          mapped.DTP?.length > 0
            ? mapped.DTP.map((row, index) => ({
                ...prev.DTP?.[index],
                ...row,
              }))
            : prev.DTP || [];

        const newDTP = mergedDTP.map((row) =>
          calculateDTPRow(
            row,
            {
              ...firstState,
              HDP: finalHDP,
              PARTP: newPARTP,
            },
            newPARTP
          )
        );

        return {
          ...prev,

          HDP: finalHDP,
          PARTP: newPARTP,
          DTP: newDTP,

          isJahresVkExist: prev.isJahresVkExist,
          isJahresEkExist: prev.isJahresEkExist,

          discountPercent: prev?.discountPercent,
          ssqr: prev?.ssqr,
        };
      });
    } catch (error) {
      console.error(" API Error:", error.message);
    }
  };

  const getReset = async () => {
    const confirm = await confirmToast(
      "Are you sure you want to reset all the fields?"
    );

    if (!confirm) return;

    // setSelectedYear("");
    // setSelectedHandler("");
    setCopyTemplate(null);
    setNewtemplateFor("");
    // setGetValue({
    //   jahresVK: "",
    //   jahresEK: "",
    // });
    setVkPlanningAllInOneNew((prev) => ({
      ...prev,
      HDP: { subJahresVK: 0 },
      // WP: {},
      DTP: [],
      PARTP: [{ typId: "KOLL" }, { typId: "NOS" }],
    }));
    await getVkPlanningDetails();
    setSelectedKey("");
    if (!resetFlag) {
      setResetFlag(true);
    }
  };

  const buildWP = (DTP = []) => {
    return DTP.flatMap((row, i) => {
      // console.log('dtp', row)
      const month = i + 1;

      return [
        {
          planMonth: month,
          typId: "KOLL",
          vororderPct: Number(row.kollVoorderPct) || null,
          vororderWert: Number(row.kollVororderWert) || null,
          nachorderPct: Number(row.kollNachorderPct) || null,
          nachorderWert: Number(row.kollNachorderWert) || null,
          totalWert: Number(row.kollTotalWert) || null,

          kollektionEkAbschlag: Number(row.kollektionEkAbschlag) || null,
          kollektionEkAufschlag: Number(row.kollektionEkAufschlag) || null,
          kollektionAkAufschlag: Number(row.kollektionAkAufschlag) || null,
          kollektionAkAbschlag: Number(row.kollektionAkAbschlag) || null,
          kollektionAuslieferungsQuote:
            Number(row.kollektionAuslieferungsQuote) || null,
          kollektionLug: Number(row.kollektionLug) || null,
          kollektionAbschriftProzentual:
            Number(row.kollektionAbschriftProzentual) || null,
          kollektionBestandAvg: Number(row.kollektionBestandAvg) || null,
        },
        {
          planMonth: month,
          typId: "NOS",
          vororderPct: Number(row.nosVororderPct) || null,
          vororderWert: Number(row.nosVororderWert) || null,
          nachorderPct: Number(row.nosNachorderPct) || null,
          nachorderWert: Number(row.nosNachorderWert) || null,
          totalWert: Number(row.nosTotalWert) || null,

          nosEkAbschlag: Number(row.nosEkAbschlag) || null,
          nosEkAufschlag: Number(row.nosEkAufschlag) || null,
          nosAkAufschlag: Number(row.nosAkAufschlag) || null,
          nosAkAbschlag: Number(row.nosAkAbschlag) || null,
          nosAuslieferungsQuote: Number(row.nosAuslieferungsQuote) || null,
          nosLug: Number(row.nosLug) || null,
          nosAbschriftProzentual: Number(row.nosAbschriftProzentual) || null,
          nosBestandAvg: Number(row.nosBestandAvg) || null,
        },
      ];
    });
  };

  const buildPayload = () => {
    const { HDP, DTP, PARTP } = vkPlanningAllInOneNew;

    const toNum = (v) => {
      if (v === "" || v === null || v === undefined) return null;
      return Number(v);
    };
    // console.log('FOid?', HDP?.FOID);
    // console.log("COID2?", HDP?.COID2)
    // console.log('HDP??', HDP)
    const dipeValue =
      vkPlanningAllInOneNew?.HDP?.DIPE ??
      vkPlanningAllInOneNew?.discountPercent;

    const finalHDP = {
      ...HDP,
      DIPE: Number(String(dipeValue).replace(",", ".")) || "",
    };
    return {
      CID: "LERROS",
      area: selectedCustomer?.cust ?? "",
      dept: selectedCustomer?.div ?? "",
      vtrGroup: selectedCustomer?.vtrGroup ?? "",
      FOID: HDP?.FOID ?? "*",
      COID2: HDP?.COID2 ?? "*",
      COID3: HDP?.COID3 ?? "*",
      COID4: HDP?.COID4 ?? "*",

      // hdp: HDP
      //   ? Object.fromEntries(
      //       Object.entries(HDP).map(([k, v]) => [k, toNum(v)])
      //     )
      //   : null,
      hdp: HDP ? finalHDP : {},

      dtp: (DTP || []).map((row, i) => ({
        ...row,
        planMonth: i + 1,
        umsatzAnteile: toNum(row.umsatzAnteile),
        planWert: toNum(row.planWert),
        planWertWeVk: toNum(row.planWertWeVk),
        planWertPct: toNum(row.planWertPct),
        planWeAmount: toNum(row.planWeAmount),
        planWertAnfangsLagerbestand: toNum(row.planWertAnfangsLagerbestand),
        abschriftenAnteilePct: toNum(row.abschriftenAnteilePct),
        planWertAbschriftenGesamt: toNum(row.planWertAbschriftenGesamt),
        isAm: toNum(row.isAm),
        isAmPy: toNum(row.isAmPy),
        isSaAm: toNum(row.isSaAm),
        isWe: toNum(row.isWe),
        isWePy: toNum(row.isWePy),
        isSaEx: toNum(row.isSaEx),
        isWeEx: toNum(row.isWeEx),
        isWeCn: toNum(row.isWeCn),
        isWapEx: toNum(row.isWapEx),
        isWapCn: toNum(row.isWapCn),
        isSaCn: toNum(row.isSaCn),
      })),

      wp: buildWP(vkPlanningAllInOneNew.DTP),

      partp: PARTP || [],
    };
  };

  // const buildWP = (DTP = []) => {
  //   return DTP.flatMap((row, i) => {
  //     // console.log('dtp', row)
  //     const month = i + 1;

  //     return [
  //       {
  //         planMonth: month,
  //         typId: "KOLL",
  //         vororderPct: Number(row.kollVoorderPct) || null,
  //         vororderWert: Number(row.kollVororderWert) || null,
  //         nachorderPct: Number(row.kollNachorderPct) || null,
  //         nachorderWert: Number(row.kollNachorderWert) || null,
  //         totalWert: Number(row.kollTotalWert) || null,

  //         kollektionEkAbschlag: Number(row.kollektionEkAbschlag) || null,
  //         kollektionEkAufschlag: Number(row.kollektionEkAufschlag) || null,
  //         kollektionAkAufschlag: Number(row.kollektionAkAufschlag) || null,
  //         kollektionAkAbschlag: Number(row.kollektionAkAbschlag) || null,
  //         kollektionAuslieferungsQuote:
  //           Number(row.kollektionAuslieferungsQuote) || null,
  //         kollektionLug: Number(row.kollektionLug) || null,
  //         kollektionAbschriftProzentual:
  //           Number(row.kollektionAbschriftProzentual) || null,
  //         kollektionBestandAvg: Number(row.kollektionBestandAvg) || null,
  //       },
  //       {
  //         planMonth: month,
  //         typId: "NOS",
  //         vororderPct: Number(row.nosVororderPct) || null,
  //         vororderWert: Number(row.nosVororderWert) || null,
  //         nachorderPct: Number(row.nosNachorderPct) || null,
  //         nachorderWert: Number(row.nosNachorderWert) || null,
  //         totalWert: Number(row.nosTotalWert) || null,

  //         nosEkAbschlag: Number(row.nosEkAbschlag) || null,
  //         nosEkAufschlag: Number(row.nosEkAufschlag) || null,
  //         nosAkAufschlag: Number(row.nosAkAufschlag) || null,
  //         nosAkAbschlag: Number(row.nosAkAbschlag) || null,
  //         nosAuslieferungsQuote: Number(row.nosAuslieferungsQuote) || null,
  //         nosLug: Number(row.nosLug) || null,
  //         nosAbschriftProzentual: Number(row.nosAbschriftProzentual) || null,
  //         nosBestandAvg: Number(row.nosBestandAvg) || null,
  //       },
  //     ];
  //   });
  // };

  // deep compare function for payload data

  // const isEmptyish = (value) => {
  //   if (value === null || value === undefined) return true;
  //   if (typeof value === "string" && value.trim() === "") return true;
  //   if (Array.isArray(value) && value.length === 0) return true;
  //   if (typeof value === "number" && !Number.isFinite(value)) return true; // catches Infinity, -Infinity, NaN
  //   if (
  //     value &&
  //     typeof value === "object" &&
  //     !Array.isArray(value) &&
  //     Object.keys(value).length === 0
  //   ) {
  //     return true;
  //   }
  //   return false;
  // };

  // const normalizeForCompare = (value) => {
  //   // Treat all "empty" representations as the same thing
  //   if (isEmptyish(value)) {
  //     return null;
  //   }

  //   // Array
  //   if (Array.isArray(value)) {
  //     return value.map(normalizeForCompare);
  //   }

  //   // Object
  //   if (typeof value === "object") {
  //     return Object.keys(value)
  //       .sort()
  //       .reduce((obj, key) => {
  //         obj[key] = normalizeForCompare(value[key]);
  //         return obj;
  //       }, {});
  //   }

  //   // String
  //   if (typeof value === "string") {
  //     const trimmed = value.trim();

  //     // German decimal:
  //     // "15,78" -> 15.78
  //     // "15.78" -> 15.78
  //     if (/^-?\d+(,\d+|\.\d+)?$/.test(trimmed)) {
  //       return Number(trimmed.replace(",", "."));
  //     }

  //     return trimmed;
  //   }

  //   return value;
  // };

  // const isSameData = (oldData, newData) => {
  //   return (
  //     JSON.stringify(normalizeForCompare(oldData)) ===
  //     JSON.stringify(normalizeForCompare(newData))
  //   );
  // };

  // const findFirstDiff = (a, b, path = "root") => {
  //   const na = normalizeForCompare(a);
  //   const nb = normalizeForCompare(b);

  //   if (na === null && nb === null) return null;

  //   if (Array.isArray(na) && Array.isArray(nb)) {
  //     if (na.length !== nb.length) {
  //       return `${path}: array length differs (${na.length} vs ${nb.length})`;
  //     }
  //     for (let i = 0; i < na.length; i++) {
  //       const diff = findFirstDiff(na[i], nb[i], `${path}[${i}]`);
  //       if (diff) return diff;
  //     }
  //     return null;
  //   }

  //   if (na && nb && typeof na === "object" && typeof nb === "object" && !Array.isArray(na)) {
  //     const aKeys = Object.keys(na);
  //     const bKeys = Object.keys(nb);
  //     const allKeys = Array.from(new Set([...aKeys, ...bKeys]));

  //     for (const key of allKeys) {
  //       const diff = findFirstDiff(na[key], nb[key], `${path}.${key}`);
  //       if (diff) return diff;
  //     }
  //     return null;
  //   }

  //   if (na !== nb) {
  //     return `${path}: OLD=${JSON.stringify(na)}  NEW=${JSON.stringify(nb)}`;
  //   }

  //   return null;
  // };


  // const getSubmit = async (fromExit = "") => {
  //   // console.log("checking flag", vkPlanning_data_for_compare)
  //   // console.log("fromExit?", fromExit);

  //   if (
  //     // fromExit === "fromExit" &&
  //     selectedCustomer?.isEditable === false
  //   ) {
  //     dispatch(setSelectedCustomerDetail({}));
  //     navigate("/customer-summary");
  //     return;
  //   }

  //   if (submitLoading) return;
  //   // setExitAndSaveLoading
  //   if (exitAndSaveLoading) return;
  //   let saveSuccess = false;
  //   let isNew = true;

  //   const jahresVK = Number(vkPlanningAllInOneNew?.HDP?.jahresVK);

  //   //=================== Form Exit + No Data Changed ===================//

  //   if (fromExit === "fromExit" && vkPlanning_data_for_compare === false) {
  //     // console.log("No changes found. Directly navigating...");

  //     await handleRelease();
  //     // dispatch(setSelectedCustomerDetail({}));
  //     dispatch(clearSelectedCustomerDetail()); // remove redux
  //     navigate("/customer-summary", { replace: true });

  //     return; // IMPORTANT: API not wortking
  //   }

  //   let soldToTransferDate = null;

  //   if (selectedCustomer?.newSoldto) {
  //     const enterAsNewCustomer = await confirmToast(
  //       "Do you want to enter this as a new customer or continue with the same customer?",
  //       {
  //         closeOnOutsideClick: false,
  //       },
  //     );

  //     // User selected "No" / same customer
  //     if (!enterAsNewCustomer) {
  //       soldToTransferDate = null;
  //     } else {
  //       // New customer selected
  //       soldToTransferDate = new Date().toISOString();

  //       // Check if new customer already has JahresVK planned
  //       if (selectedCustomer?.jahresVk) {
  //         const overrideExisting = await confirmToast(
  //           "This new customer is already planned. Do you want to override this new customer?",
  //           {
  //             closeOnOutsideClick: false,
  //           },
  //         );

  //         if (!overrideExisting) {
  //           return;
  //         }
  //       }
  //     }
  //   }

  //   //=================== Form Exit + Data Changed ===================//

  //   if (fromExit === "fromExit") {
  //     const confirmForExit = await confirmToast(
  //       "Do you want to save changes?",
  //       { closeOnOutsideClick: false },
  //     );
  //     if (!confirmForExit) {
  //       await handleRelease();
  //       return;
  //     }
  //   }

  //   //=================== Validate JahresVK ===================//

  //   if (!Number.isFinite(jahresVK) || jahresVK < 1) {
  //     toast.error("JahresVk's value must be greater than 0.");
  //     return;
  //   }

  //   //=================== NORMAL SUBMIT  ===================//

  //   if (fromExit === "" || !fromExit) {
  //     const confirmForAll = await confirmToast(
  //       "Are you sure you want to proceed with planning?",
  //       { closeOnOutsideClick: false },
  //     );
  //     if (!confirmForAll) return;
  //   }

  //   try {
  //     //=================== Build current payload first ===================//
  //     const payload = buildPayload();
  //     // console.log("payload?", payload);

  //     // return;

  //     if (fromExit === "") {
  //       setSubmitLoading(true);
  //     } else {
  //       setExitAndSaveLoading(true);
  //     }

  //     //=================== SAVE API ===================//
  //     const res = await axios.post(
  //       `${process.env.REACT_APP_API_LINK}/api/v1/entry/saveVkPlanData`,
  //       payload,
  //       {
  //         params: {
  //           soldTo: newTemplateForAll?.soldTo,
  //           shipTo: newTemplateForAll?.shipTo,
  //           year: newTemplateForAll?.year,
  //           div: newTemplateForAll?.div,
  //           forAllShipTo: false,
  //         },
  //         headers: {
  //           Authorization: `Bearer ${authToken}`,
  //         },
  //       },
  //     );

  //     //=================== SAVE SUCCESS ===================//

  //     if (res.data?.success) {
  //       saveSuccess = true;
  //       if (vkPlanningAllInOneNew?.isJahresVkExist === true) {
  //         isNew = false;
  //       } else {
  //         isNew = true;
  //       }
  //     }
  //   } catch (err) {
  //     console.error("Save error:", err);
  //     toast.dismiss();
  //     toast.error("Failed to save data!");
  //   } finally {
  //     if (fromExit === "" || !fromExit) {
  //       setSubmitLoading(false);
  //     } else {
  //       setExitAndSaveLoading(false);
  //     }
  //   }

  //   //=================== RELEASE AFTER SUCCESSFUL SAVE ===================//
  //   if (saveSuccess) {
  //     await handleRelease(saveSuccess, isNew);
  //   }
  // };

  const PRESERVE_KEYS = new Set([
    "id",
    "planMonth",
    "CID",
    "area",
    "dept",
    "vtrGroup",
    "soldTo",
    "shipTo",
    "typId",
    "FOID",
    "COID2",
    "COID3",
    "COID4",
  ]);

  const buildZeroPayload = (payload) => {
    const zeroed = JSON.parse(JSON.stringify(payload));

    const zeroOutNumbers = (obj) => {
      if (Array.isArray(obj)) {
        obj.forEach((item) => zeroOutNumbers(item));
        return;
      }
      if (obj && typeof obj === "object") {
        Object.keys(obj).forEach((key) => {
          if (PRESERVE_KEYS.has(key)) return; // identifiers stay untouched
          const val = obj[key];
          if (typeof val === "number") {
            obj[key] = 0;
          } else if (val && typeof val === "object") {
            zeroOutNumbers(val);
          }
        });
      }
    };

    zeroOutNumbers(zeroed);
    return zeroed;
  };

  const getSubmit = async (fromExit = "") => {
    if (selectedCustomer?.isEditable === false) {
      dispatch(setSelectedCustomerDetail({}));
      navigate("/customer-summary");
      return;
    }

    if (selectedCustomer?.newSoldTo && soldToDecision === null) {
      setShowSoldToDecisionModal(true);
      toast.error("Please choose how to handle SoldTo 0 first.");
      return;
    }

    if (submitLoading) return;
    if (exitAndSaveLoading) return;

    let saveSuccess = false;
    let isNew = true;

    const jahresVK = Number(vkPlanningAllInOneNew?.HDP?.jahresVK);

    if (fromExit === "fromExit" && vkPlanning_data_for_compare === false) {
      await handleRelease();
      dispatch(clearSelectedCustomerDetail());
      navigate("/customer-summary", { replace: true });
      return;
    }

    if (fromExit === "fromExit") {
      const confirmForExit = await confirmToast(
        "Do you want to save changes?",
        { closeOnOutsideClick: false }
      );

      if (!confirmForExit) {
        await handleRelease();
        return;
      }
    }

    if (!selectedCustomer?.newSoldTo) {
      if (!Number.isFinite(jahresVK) || jahresVK < 1) {
        toast.error("JahresVk's value must be greater than 0.");
        return;
      }
    }

    if (fromExit === "" || !fromExit) {
      const confirmForAll = await confirmToast(
        "Are you sure you want to proceed with planning?",
        { closeOnOutsideClick: false }
      );

      if (!confirmForAll) return;
    }

    const hasNewSoldToFlow = !!selectedCustomer?.newSoldTo;
    const soldToTransferDate = hasNewSoldToFlow
      ? new Date().toISOString()
      : null;

    const isZeroAndNewEntry =
      hasNewSoldToFlow && soldToDecision === "zeroAndNewEntry";
    const isZeroOnly = hasNewSoldToFlow && soldToDecision === "zeroOnly";

    // Confirm override BEFORE touching anything — "no" cancels the
    // whole submit, including the old-customer zero-out.
    if (isZeroAndNewEntry && getValue?.newEntryExists === true) {
      const overrideExisting = await confirmToast(
        "This new customer already has a plan entry. Do you want to override and submit?",
        { closeOnOutsideClick: false }
      );

      if (!overrideExisting) {
        return; // cancel — nothing happens
      }
    }

    try {
      const payload = buildPayload();

      if (fromExit === "") {
        setSubmitLoading(true);
      } else {
        setExitAndSaveLoading(true);
      }

      if (hasNewSoldToFlow) {
        //======================================================
        // 1) ALWAYS zero-out the OLD customer's plan
        //======================================================
        const zeroPayload = buildZeroPayload(payload);

        const zeroRes = await axios.post(
          `${process.env.REACT_APP_API_LINK}/api/v1/entry/saveVkPlanData`,
          zeroPayload,
          {
            params: {
              soldTo: selectedCustomer?.soldTo,
              shipTo: selectedCustomer?.shipTo,
              year: newTemplateForAll?.year,
              div: newTemplateForAll?.div,
              forAllShipTo: false,
              soldToTransferDate,
            },
            headers: { Authorization: `Bearer ${authToken}` },
          }
        );

        let newRes = null;

        //======================================================
        // 2) Only for "zeroAndNewEntry": save the REAL payload
        //    under the NEW customer
        //======================================================
        if (isZeroAndNewEntry) {
          newRes = await axios.post(
            `${process.env.REACT_APP_API_LINK}/api/v1/entry/saveVkPlanData`,
            payload,
            {
              params: {
                soldTo: selectedCustomer?.newSoldTo,
                shipTo: selectedCustomer?.newShipTo,
                year: newTemplateForAll?.year,
                div: newTemplateForAll?.div,
                forAllShipTo: false,
                // soldToTransferDate,
              },
              headers: { Authorization: `Bearer ${authToken}` },
            }
          );
        }

        const allSucceeded =
          zeroRes?.data?.success && (isZeroOnly || newRes?.data?.success);

        if (allSucceeded) {
          saveSuccess = true;
          isNew = vkPlanningAllInOneNew?.isJahresVkExist !== true;
        }
      } else {
        //======================================================
        // STANDARD SAVE — no new-soldTo flow involved at all
        //======================================================
        const res = await axios.post(
          `${process.env.REACT_APP_API_LINK}/api/v1/entry/saveVkPlanData`,
          payload,
          {
            params: {
              soldTo: newTemplateForAll?.soldTo,
              shipTo: newTemplateForAll?.shipTo,
              year: newTemplateForAll?.year,
              div: newTemplateForAll?.div,
              forAllShipTo: false,
              // soldToTransferDate,
            },
            headers: { Authorization: `Bearer ${authToken}` },
          }
        );

        if (res.data?.success) {
          saveSuccess = true;
          isNew = vkPlanningAllInOneNew?.isJahresVkExist !== true;
        }
      }
    } catch (err) {
      console.error("Save error:", err);
      toast.dismiss();
      toast.error("Failed to save data!");
    } finally {
      if (fromExit === "" || !fromExit) {
        setSubmitLoading(false);
      } else {
        setExitAndSaveLoading(false);
      }
    }

    if (saveSuccess) {
      await handleRelease(saveSuccess, isNew);
    }
  };

  const getDelete = async () => {
    if (!vkPlanningAllInOneNew?.HDP?.soldTo) {
      toast.dismiss();
      // toast.error("You have not selected any sold-to to delete planning");
      toast.error("There is no planning for this sold-to");
      return;
    }

    const confirmForAll = await confirmToast(
      `Are you sure you want to delete this planning for customer ${vkPlanningAllInOneNew?.HDP?.soldTo}?`
    );
    if (!confirmForAll) return;

    const api = `${process.env.REACT_APP_API_LINK}/api/v1/entry/deleteVkPlanData?soldTo=${vkPlanningAllInOneNew?.HDP?.soldTo}&division=${selectedHandler}&planYear=${selectedYear}&shipTo=${newTemplateForAll.shipTo}`;
    setDeleteLoading(true);
    try {
      const res = await axios.delete(api, {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "application/json",
        },
      });

      // console.log(res);

      toast.dismiss(); // clear old toasts
      toast.success("Deleted Successfully!", { autoClose: 2000 });
      // dispatch(setSelectedCustomerDetail({}));
      // await handleRelease();
      // 2. Release API
      // isDelete = true => "Entry released successfully!" nahi dikhega
      await handleRelease(false, true, true);
      dispatch(clearSelectedCustomerDetail()); // remove redux8
      navigate("/customer-summary", { replace: true });
      // getReset();
    } catch (err) {
      const errorMsg = err.response?.data?.message || "Something went wrong";

      toast.dismiss();
      toast.error(errorMsg, { autoClose: 2000 });
      console.log(errorMsg);
    } finally {
      setDeleteLoading(false);
    }
  };

  const formatDate = (date) => {
    const d = new Date(date);

    const formattedDate = d.toLocaleDateString("en-GB");

    //  am to bin and pm to uhm in german
    const formattedTime = (() => {
      const h = d.getHours();
      const m = d.getMinutes();
      const hour12 = h % 12 || 12;
      const minutes = String(m).padStart(2, "0");
      const suffix = h < 12 ? "Bin" : "Uhr";
      return `${hour12}:${minutes} ${suffix}`;
    })();

    return `${formattedDate}   ${formattedTime}`;
  };

  const compareDates = [
    vkPlanningAllInOneNew?.HDP?.updatedAt,
    vkPlanningAllInOneNew?.PARTP?.[0]?.updatedAt,
  ]?.filter(Boolean);

  let latestDate = null;

  if (compareDates.length > 0) {
    latestDate = new Date(Math.max(...compareDates.map((d) => new Date(d))));
  }

  const formattedTime = latestDate ? formatDate(latestDate) : "";

  const getVkPlanningDetails = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_LINK}/api/v1/entry/getVkPlanning?soldTo=${
          newTemplateFor || newTemplateForAll.soldTo
        }&division=${selectedHandler}&planYear=${selectedYear}&shipTo=${
          newTemplateForAll.shipTo
        }&newSoldTo=${selectedCustomer?.newSoldTo}&newShipTo=${
          selectedCustomer?.shipTo
        }`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      setPlanningLock(res.data.lock);
      // console.log("planningLock", res.data.lock);
      localStorage.setItem("planningLock", res.data.lock.expiresAt);
      new Date(Number(localStorage.getItem("planningLockTime"))).toLocaleString(
        "en-IN",
        { timeZone: "Asia/Kolkata" }
      );
      const avg = (a, b) => ((Number(a) || 0) + (Number(b) || 0)) / 2;
      const responseData = res.data.data;
      const { HDP, PARTP, DTP } = responseData;
      const avgEingangskalkulationAufschlag = avg(
        PARTP?.[0]?.estimatedCalc,
        PARTP?.[1]?.estimatedCalc
      );
      const avgEingangskalkulationAbschlag = avg(
        PARTP?.[0]?.estimatedCalcDisc,
        PARTP?.[1]?.estimatedCalcDisc
      );

      // const nachRabatt2 =
      //   (avgEingangskalkulationAufschlag * 100) /
      //   (100 +
      //     (avgEingangskalkulationAufschlag -
      //       (avgEingangskalkulationAufschlag *
      //         Number(responseData?.HDP?.DIPE)) /
      //       100));
      // const nachRabatt4 =
      //   ((100 + responseData?.HDP?.abschriftPercent) / 100) * nachRabatt2 -
      //   responseData?.HDP?.abschriftPercent;

      const avgAusgangskalkulationAufschlag = avg(
        PARTP?.[0]?.outgoingCalc,
        PARTP?.[1]?.outgoingCalc
      );

      const avgAusgangskalkulationAbschlag = avg(
        PARTP?.[0]?.outgoingCalcDisc,
        PARTP?.[1]?.outgoingCalcDisc
      );

      const nachRabatt1 =
        ((avgEingangskalkulationAufschlag + 100) / (100 - Number(HDP?.DIPE))) *
          100 -
        100;

      const nachRabatt2 =
        100 -
        ((100 - avgEingangskalkulationAbschlag) * (100 - Number(HDP?.DIPE))) /
          100;

      const nachRabatt3 =
        (((avgEingangskalkulationAufschlag + 100) *
          (100 - HDP?.abschriftPercent)) /
          100 /
          (100 - HDP?.DIPE)) *
          100 -
        100;

      const nachRabatt4 =
        100 -
        ((100 - avgAusgangskalkulationAbschlag) * (100 - HDP?.DIPE)) / 100;

      const kollPercred = parseFloat(responseData?.PARTP?.[0]?.percred || 0);
      const nosPercred = parseFloat(responseData?.PARTP?.[1]?.percred || 0);
      const kollEstimatedCalcDisc = parseFloat(
        responseData?.PARTP?.[0]?.estimatedCalcDisc || 0
      );
      const nosEstimatedCalcDisc = parseFloat(
        responseData?.PARTP?.[1]?.estimatedCalcDisc || 0
      );

      // const kollOutgoingCalcDisc =
      //   (((100 * (100 - kollPercred)) / 100 - (100 - kollEstimatedCalcDisc)) /
      //     (100 - kollPercred)) *
      //   100;

      // const nosOutgoingCalcDisc =
      //   (((100 * (100 - nosPercred)) / 100 - (100 - nosEstimatedCalcDisc)) /
      //     (100 - nosPercred)) *
      //   100;

      const kollOutgoingCalcDisc =
        ((100 + kollPercred) / 100) * kollEstimatedCalcDisc - kollPercred;

      const nosOutgoingCalcDisc =
        ((100 + nosPercred) / 100) * nosEstimatedCalcDisc - nosPercred;

      const kollOutgoingCalc =
        (kollOutgoingCalcDisc * 100) / (100 - kollOutgoingCalcDisc);

      const nosOutgoingCalc =
        (nosOutgoingCalcDisc * 100) / (100 - nosOutgoingCalcDisc);

      const finalPARTP =
        Array.isArray(responseData?.PARTP) && responseData.PARTP.length > 0
          ? responseData.PARTP.map((item, index) => ({
              ...item,
              outgoingCalc: index === 0 ? kollOutgoingCalc : nosOutgoingCalc,
              outgoingCalcDisc:
                index === 0 ? kollOutgoingCalcDisc : nosOutgoingCalcDisc,
            }))
          : [{ typId: "KOLL" }, { typId: "NOS" }];

      setVkPlanningAllInOneNew({
        HDP: {
          ...responseData?.HDP,
          DIPE:
            responseData?.HDP.DIPE ??
            (Number(String(responseData?.discountPercent).replace(",", ".")) ||
              0),
          // nachRabatt2: nachRabatt2,
          // nachRabatt1: (nachRabatt2 * 100) / (100 - nachRabatt2),
          // nachRabatt4: nachRabatt4,
          // nachRabatt3: (nachRabatt4 * 100) / (100 - nachRabatt4),
          nachRabatt1: nachRabatt1,
          nachRabatt2: nachRabatt2,
          nachRabatt3: nachRabatt3,
          nachRabatt4: nachRabatt4,
          lugPlan: responseData?.HDP?.jahresVK / responseData?.HDP?.bestandAvg,
        } || { subJahresVK: 0 },
        // WP: responseData?.WP || {},
        DTP: responseData?.DTP || [],
        PARTP: finalPARTP,
        isJahresVkExist: !!responseData?.HDP?.jahresVK,
        isJahresEkExist: !!responseData?.HDP?.jahresEK,
        ssqr: responseData?.ssqr || "",
        discountPercent:
          Number(String(responseData?.discountPercent).replace(",", ".")) || "",
      });

      // setJahresEkHdr(res?.data?.data?.jahresEk);
      // setJahresVkHdr(res?.data?.data?.jahresVk);
      setGetValue({
        ...res?.data?.data,
      });
    } catch (error) {
      console.log("error:", error);
    } finally {
      setVkPlanningLoaded(true);
    }
    // setAPIgetIstDetails(formattedData);
  };

  useEffect(() => {
    if (
      selectedHandler !== "" &&
      selectedYear !== "" &&
      newTemplateFor !== ""
    ) {
      getVkPlanningDetails();
    }
  }, [selectedHandler, selectedYear, newTemplateFor]);

  const pairs = {
    kollSumTotalPct: "nosSumTotalPct",
    nosSumTotalPct: "kollSumTotalPct",

    kollSumVororderPct: "kollSumNachorderPct",
    kollSumNachorderPct: "kollSumVororderPct",

    nosSumVororderPct: "nosSumNachorderPct",
    nosSumNachorderPct: "nosSumVororderPct",
  };

  const validationRules = {
    HDP: {
      default: /^\d{0,10}([.,]\d{0,2})?$/,
    },

    PARTP: {
      default: /^\d{0,3}([.,]\d{0,2})?$/, // example: 100.00 max
    },

    DTP: {
      default: /^\d{0,3}([.,]\d{0,2})?$/,
    },
  };

  const updatePlanWertPct = (dtp) => {
    const total = dtp.reduce(
      (sum, row) => sum + (Number(row.planWeAmount) || 0),
      0
    );

    return dtp.map((row) => ({
      ...row,
      planWertPct: total > 0 ? (Number(row.planWeAmount) / total) * 100 : 0,
    }));
  };

  const handleChangeForAll = (section, e, index = null) => {
    const { name, value: rawValue } = e.target;
    setVkPlanning_data_for_compare(true);

    let cleanedValue;

    if (name === "DIPE") {
      cleanedValue = rawValue.replace(",", ".");
    } else {
      const parts = rawValue.split(",");
      cleanedValue = parts[0].replace(/\./g, "");
      if (parts.length > 1) {
        cleanedValue += "," + parts[1]; // only add comma if user typed one
      }
    }

    // console.log('cleaned value:', cleanedValue);

    // let cleanedValue = rawValue.replace(/\./g, "");

    // if (rawValue.includes(",")) {
    //   const parts = rawValue.split(",");
    //   cleanedValue = parts[0].replace(/\./g, "") + "," + (parts[1] || "");
    // }

    const rule =
      validationRules?.[section]?.[name] || validationRules?.[section]?.default;

    if (rule && !rule.test(cleanedValue)) return;

    let value = cleanedValue;

    // value = rawValue.replace(".", ",");

    setVkPlanningAllInOneNew((prev) => {
      let newState = { ...prev };

      if (section === "DTP") {
        const updated = [...prev.DTP];

        const baseRow = {
          ...updated[index],
          [name]: value,
        };

        updated[index] = calculateDTPRow(baseRow, prev, prev.PARTP);

        // // Calculate total Plan WE Amount of all months
        // const totalPlanWeAmount = updated.reduce(
        //   (sum, row) => sum + (Number(row.planWeAmount) || 0),
        //   0,
        // );

        // // Update percentage for all months
        // const finalDTP = updated.map((row) => ({
        //   ...row,
        //   planWertPct:
        //     totalPlanWeAmount > 0
        //       ? (Number(row.planWeAmount) / totalPlanWeAmount) * 100
        //       : 0,
        // }));

        // console.log('final Dtp from handlechange?', finalDTP)

        return {
          ...prev,
          DTP: updatePlanWertPct(updated),
        };
      }

      if (section === "PARTP") {
        const updatedPARTP = [...prev.PARTP];

        updatedPARTP[index] = {
          ...updatedPARTP[index],
          [name]: value, // keep raw typing value
        };

        const normalized = value.replace(",", ".");
        const parsed = Number(normalized);

        // KOLL + NOS = 100
        if (name === "percValue" && !Number.isNaN(parsed)) {
          const otherIndex = updatedPARTP.findIndex((_, i) => i !== index);

          if (otherIndex !== -1) {
            updatedPARTP[otherIndex] = {
              ...updatedPARTP[otherIndex],
              percValue: 100 - parsed,
            };
          }
        }

        const koll = updatedPARTP.find((r) => r.typId === "KOLL");
        const nos = updatedPARTP.find((r) => r.typId === "NOS");

        // const avg = (a, b) => ((Number(a) || 0) + (Number(b) || 0)) / 2;
        const avg = (a, b) => ((Number(a) || 0) + (Number(b) || 0)) / 2;

        const avgEingangskalkulationAufschlag = avg(
          koll?.estimatedCalc,
          nos?.estimatedCalc
        );
        const avgEingangskalkulationAbschlag = avg(
          koll?.estimatedCalcDisc,
          nos?.estimatedCalcDisc
        );

        const avgAusgangskalkulationAufschlag = avg(
          koll?.outgoingCalc,
          nos?.outgoingCalc
        );

        const avgAusgangskalkulationAbschlag = avg(
          koll?.outgoingCalcDisc,
          nos?.outgoingCalcDisc
        );
        const totalWareAbschriftPercent = avg(koll?.percred, nos?.percred);

        const baseHDP = {
          ...prev.HDP,

          // Average of KOLL + NOS
          avgEingangskalkulationAufschlag: avgEingangskalkulationAufschlag,
          avgEingangskalkulationAbschlag: avgEingangskalkulationAbschlag,

          eingangskalkulationAufschlag:
            ((avgEingangskalkulationAufschlag + 100) / (100 - 0)) * 100 - 100,

          eingangskalkulationAbschlag:
            100 - ((100 - avgEingangskalkulationAbschlag) * (100 - 0)) / 100,

          // ausgangskalkulationAufschlag:
          //   (((avgEingangskalkulationAufschlag + 100) *
          //     (100 - totalWareAbschriftPercent)) /
          //     100 /
          //     (100 - prev?.HDP?.DIPE)) *
          //     100 -
          //   100,
          ausgangskalkulationAufschlag: avgAusgangskalkulationAufschlag,

          ausgangskalkulationAbschlag: avgAusgangskalkulationAbschlag,

          // ausgangskalkulationAbschlag:
          //   100 -
          //   ((100 - avgAusgangskalkulationAbschlag) * (100 - prev?.HDP?.DIPE)) /
          //     100,

          auslieferungsQuote: avg(koll?.delivQuota, nos?.delivQuota),

          lug: avg(koll?.lugPlan, nos?.lugPlan),

          abschriftPercent: avg(koll?.percred, nos?.percred),

          bestandAvg: avg(koll?.planStockAvail, nos?.planStockAvail),
        };

        // const updatedHDP =
        //   name === "estimatedCalc" ? calculateHDP(baseHDP) : baseHDP;

        const tempStateForHDP = {
          ...prev,
          PARTP: updatedPARTP,
        };

        const updatedHDP = calculateHDP(baseHDP, tempStateForHDP);

        const tempState = {
          ...prev,
          HDP: updatedHDP,
        };

        const newPARTP = calculatePARTP(updatedPARTP, tempState);

        const newDTP = prev.DTP.map((row) =>
          calculateDTPRow(row, tempState, newPARTP)
        );

        return {
          ...tempState,
          PARTP: newPARTP,
          DTP: updatePlanWertPct(newDTP),
        };
      }

      if (section === "HDP") {
        if (
          (name === "jahresVK" || name === "jahresEK") &&
          !/^\d*$/.test(value)
        ) {
          return prev;
        }

        let updatedHDP = calculateHDP(
          {
            ...prev.HDP,
            [name]: value,
          },
          prev
        );

        let state = {
          ...prev,
          HDP: updatedHDP,
        };

        const newPARTP = calculatePARTP(prev.PARTP, state);

        updatedHDP = calculateHDPFromPARTP(updatedHDP, newPARTP);

        state = {
          ...state,
          HDP: updatedHDP,
          PARTP: newPARTP,
        };

        const newDTP = state.DTP.map((row) =>
          calculateDTPRow(row, state, newPARTP)
        );

        return {
          ...state,
          DTP: updatePlanWertPct(newDTP),
        };
      }

      return prev;
    });
  };

  const clampPct = (v) => Math.min(100, Math.max(0, Number(v) || 0));

  const percentageFields = ["percValue", "prePerc"];

  const handleBlurForAll = (section, e, index = null) => {
    const { name, value } = e.target;
    setVkPlanning_data_for_compare(true);

    if (value === "" || value === undefined || value === null) return;

    const normalized = value.replace(/\./g, "").replace(",", ".");

    const num = Number(normalized);

    if (Number.isNaN(num)) return;

    const fixed2Fields = [
      "umsatzAnteile",
      "nosNachorderPct",
      "kollNachorderPct",
    ];

    const finalValue = fixed2Fields.includes(name)
      ? Number(num.toFixed(2))
      : num;

    setVkPlanningAllInOneNew((prev) => {
      // ---------------- DTP ----------------
      if (section === "DTP") {
        const updated = [...prev.DTP];

        const baseRow = {
          ...updated[index],
          [name]: finalValue,
        };

        // updated[index] = calculateDTPRow(baseRow, prev, prev.WP);
        updated[index] = calculateDTPRow(baseRow, prev, prev.PARTP);

        return {
          ...prev,
          DTP: updatePlanWertPct(updated),
        };
      }

      if (section === "PARTP") {
        const clamped = percentageFields.includes(name)
          ? clampPct(finalValue)
          : finalValue;

        const updatedPARTP = [...prev.PARTP];

        updatedPARTP[index] = {
          ...updatedPARTP[index],
          [name]: parseFloat(clamped),
        };

        // KOLL + NOS = 100
        if (name === "percValue") {
          const otherIndex = updatedPARTP.findIndex((_, i) => i !== index);

          if (otherIndex !== -1) {
            updatedPARTP[otherIndex] = {
              ...updatedPARTP[otherIndex],
              percValue: 100 - Number(clamped),
            };
          }
        }

        const koll = updatedPARTP.find((r) => r.typId === "KOLL");
        const nos = updatedPARTP.find((r) => r.typId === "NOS");

        const avg = (a, b) => ((Number(a) || 0) + (Number(b) || 0)) / 2;
        // const toNum = (v) => Number(String(v).replace(",", ".")) || 0;
        // const avg = (a, b) => (toNum(a) + toNum(b)) / 2;

        const avgEingangskalkulationAufschlag = avg(
          koll?.estimatedCalc,
          nos?.estimatedCalc
        );
        const avgEingangskalkulationAbschlag = avg(
          koll?.estimatedCalcDisc,
          nos?.estimatedCalcDisc
        );

        const avgAusgangskalkulationAufschlag = avg(
          koll?.outgoingCalc,
          nos?.outgoingCalc
        );

        const avgAusgangskalkulationAbschlag = avg(
          koll?.outgoingCalcDisc,
          nos?.outgoingCalcDisc
        );
        const totalWareAbschriftPercent = avg(koll?.percred, nos?.percred);

        const baseHDP = {
          ...prev.HDP,

          avgEingangskalkulationAufschlag: avgEingangskalkulationAufschlag,
          avgEingangskalkulationAbschlag: avgEingangskalkulationAbschlag,

          eingangskalkulationAufschlag:
            ((avgEingangskalkulationAufschlag + 100) / (100 - 0)) * 100 - 100,

          eingangskalkulationAbschlag:
            100 - ((100 - avgEingangskalkulationAbschlag) * (100 - 0)) / 100,

          ausgangskalkulationAufschlag: avgAusgangskalkulationAufschlag,

          ausgangskalkulationAbschlag: avgAusgangskalkulationAbschlag,

          auslieferungsQuote: avg(koll?.delivQuota, nos?.delivQuota),

          lug: avg(koll?.lugPlan, nos?.lugPlan),

          abschriftPercent: avg(koll?.percred, nos?.percred),

          bestandAvg: avg(koll?.planStockAvail, nos?.planStockAvail),
        };

        // const updatedHDP =
        //   name === "estimatedCalc" ? calculateHDP(baseHDP) : baseHDP;
        const tempStateForHDP = {
          ...prev,
          PARTP: updatedPARTP,
        };

        const updatedHDP = calculateHDP(baseHDP, tempStateForHDP);

        const tempState = {
          ...prev,
          HDP: updatedHDP,
        };

        const newPARTP = calculatePARTP(updatedPARTP, tempState);

        const newDTP = prev.DTP.map((row) =>
          calculateDTPRow(row, tempState, newPARTP)
        );

        return {
          ...tempState,
          PARTP: newPARTP,
          DTP: updatePlanWertPct(newDTP),
        };
      }

      // ---------------- HDP ----------------
      if (section === "HDP") {
        let updatedHDP = calculateHDP(
          {
            ...prev.HDP,
            [name]: finalValue,
          },
          prev
        );

        let state = {
          ...prev,
          HDP: updatedHDP,
        };

        const newPARTP = calculatePARTP(prev.PARTP, state);

        updatedHDP = calculateHDPFromPARTP(updatedHDP, newPARTP);

        state = {
          ...state,
          HDP: updatedHDP,
          PARTP: newPARTP,
        };

        const newDTP = state.DTP.map((row) =>
          calculateDTPRow(row, state, state.PARTP)
        );

        return {
          ...state,
          DTP: updatePlanWertPct(newDTP),
        };
      }

      return prev;
    });
  };

  // console.log("single data api?", singleApiData);

  // customer Summary to Vk planning .js file  compare

  useEffect(() => {
    // same description template find
    const matchedTemplate = uniqTemplates.find(
      (item) => item.description === selectedCustomer?.templateDes
    );

    // auto select
    if (matchedTemplate) {
      setCopyTemplate(matchedTemplate);
    }
  }, [selectedCustomer?.templateDes, uniqTemplates]);

  const handleRelease = async (
    saveSuccess = false,
    isNew = true,
    isDelete = false
  ) => {
    // const confirm = await confirmToast(
    //   "Are you sure you want to release this customer?"
    // );

    // if (!confirm) return;

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_LINK}/api/v1/entry/unlockEntry`,
        {
          soldTo: planningLock?.soldTo,
          shipTo: planningLock?.shipTo,
          planYear: planningLock?.planYear,
          division: planningLock?.division,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (res.data.success) {
        setPlanningLock(null);
        if (saveSuccess === true) {
          toast.success(
            `VK Planning ${
              isNew ? "created" : "updated"
            } and released successfully!`
          );
        }

        // Delete ke case me ye toast nahi dikhega
        else if (!isDelete) {
          // console.log("CheckDeleteFlag>>>>>>>>>>>Entry released successfully!", CheckDeleteFlag);
          toast.success("Entry released successfully!");
        }

        dispatch(
          // setSelectedCustomerDetail({
          //   ...selectedCustomer,
          //   isLockPlanning: false,
          // })
          // setSelectedCustomerDetail({}),
          clearSelectedCustomerDetail() // remove redux
        );
        navigate("/customer-summary", { replace: true });
      }
    } catch (error) {
      console.log("error:", error);
      toast.error("Something went wrong");
    }
  };

  const handleTimerExpired = () => {
    // toast.success("Lock expired.");

    // dispatch(setSelectedCustomerDetail({}));
    dispatch(clearSelectedCustomerDetail()); // remove redux
    navigate("/customer-summary", { replace: true });
  };

  // console.log("vkplanning new?", vkPlanningAllInOneNew);
  // console.log("planning lock?", planningLock);

  return (
    <div className="planning_main_container">
      <div className="planning_main">
        <div className="main_planning">
          <div className="planning_header_main">
            <Header />
            <Row className="planning_header">
              <Col lg={6} md={6}>
                <Row className="ml-2">
                  <Col
                    md={2}
                    lg={2}
                    xl={2}
                    xxl={2}
                    className="user_id_main_planning"
                  >
                    <div className="user_id_main_planning_text">
                      <Form.Label
                        htmlFor="username"
                        className="user_id_text_planning"
                      >
                        Jahr
                      </Form.Label>
                    </div>
                    <div className="dropDown_jahr_planning">
                      <select
                        name="jahrDropdown"
                        className="form-select dropDown_jahr"
                        value={selectedYear}
                        onChange={getFunction}
                        // readOnly
                        disabled={vkPlanningAllInOneNew?.isJahresVkExist}
                      >
                        <option value="">Select Jahr</option>
                        <option>{selectedYear}</option>
                      </select>
                    </div>
                  </Col>
                  <Col
                    md={2}
                    lg={2}
                    xl={2}
                    xxl={2}
                    className="user_id_main_planning"
                  >
                    <div className="user_id_main_planning_text">
                      <Form.Label
                        htmlFor="username"
                        className="user_id_text_planning"
                      >
                        Div
                      </Form.Label>
                    </div>
                    <div className="dropDown_jahr_planning">
                      <select
                        name="divDropdown"
                        className="form-select dropDown_jahr "
                        value={selectedHandler}
                        onChange={getFunction}
                        // readOnly
                        disabled={vkPlanningAllInOneNew?.isJahresVkExist}
                      >
                        <option value="">Select Div</option>
                        <option>{selectedHandler}</option>
                      </select>
                    </div>
                  </Col>
                  <Col
                    md={3}
                    lg={3}
                    xl={3}
                    xxl={3}
                    className="copy_template_main_planning"
                  >
                    <div className="copy_template_main_planning_text">
                      <Form.Label
                        htmlFor="username"
                        className="copy_template_text_planning"
                      >
                        Aus Vorgabe kopieren
                      </Form.Label>
                    </div>
                    <div className="copy_template_planning">
                      <select
                        name="copyTemplate"
                        className="form-select dropDown_jahr"
                        value={copyTemplate?.soldTo || ""}
                        onChange={getFunction}
                        disabled={vkPlanningAllInOneNew?.isJahresVkExist}
                      >
                        <option value="">Select Template</option>

                        {uniqTemplates.length > 0 ? (
                          uniqTemplates.map((item, index) => (
                            <option
                              value={item.soldTo}
                              key={index}
                              className="dropDown_jahr"
                            >
                              {item.soldTo} | {item.description}
                            </option>
                          ))
                        ) : (
                          <option
                            readOnly
                            className="vk-planning-noTemplateFound"
                          >
                            No template at this moment...
                          </option>
                        )}
                      </select>
                    </div>
                  </Col>

                  <Col
                    md={5}
                    lg={5}
                    xl={5}
                    // xxl={4}
                    className="copy_template_main_planning"
                  >
                    <div className="copy_template_main_planning_text">
                      <Form.Label
                        htmlFor="username"
                        className="copy_template_text_planning"
                      >
                        VK Planung für
                      </Form.Label>
                    </div>

                    <div
                      // className="copy_template_planning"
                      className="w-100"
                    >
                      {/* <VirtualizedSelect
                      options={optionsForVkPlanning}
                      value={selectedKey} // simple value (for react-select)
                      onChange={setSelectedKey} // setter for simple value
                      setNewtemplateFor={setNewtemplateFor}
                      setNewtemplateForAll={setNewtemplateForAll} // setter for full object
                      placeholder="Select Customer"
                    /> */}
                      <Form.Control
                        type="text"
                        readOnly
                        size="sm"
                        // className="w-100"
                        value={`${newTemplateForAll.soldTo}   ${newTemplateForAll.shipTo}   ${newTemplateForAll.name}   ${newTemplateForAll.city}   ${newTemplateForAll.vtr}  ${newTemplateForAll.address1}`}
                      />
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col className="vkPlanning-btn-main">
                <div>
                  <ReleaseTime
                    expiresAt={planningLock?.expiresAt}
                    // onRelease={handleRelease}
                    onExpired={handleTimerExpired}
                  />
                </div>

                <div>
                  <button
                    type="button"
                    className="btn btn-secondary vkplanning-submitBtn"
                    readOnly={exitAndSaveLoading}
                    onClick={() => getSubmit("fromExit")}
                  >
                    {/* Beenden */}
                    {exitAndSaveLoading ? (
                      <div id="loading_both">
                        <i id="spinner" className="fa fa-spinner fa-spin"></i>
                      </div>
                    ) : (
                      "Beenden"
                    )}
                  </button>
                </div>

                <div>
                  <button
                    type="button"
                    className="btn btn-success vkplanning-submitBtn"
                    onClick={() => {
                      alert("under Development");
                    }}
                  >
                    {/* Print */}
                    Druck
                  </button>
                </div>
                {/* </Col> */}

                {/* <Col md={1} lg={1} xl={1} xxl={1} className="header-buttons"> */}
                <div>
                  <button
                    type="button"
                    className="btn btn-danger vkplanning-submitBtn"
                    onClick={getReset}
                  >
                    Zurücksetzen
                  </button>
                </div>
                {/* </Col> */}
                {/* <Col md={1} lg={1} xl={1} xxl={1} className="header-buttons"> */}
                <div>
                  <button
                    type="button"
                    className="btn btn-primary vkplanning-submitBtn2"
                    onClick={() => getSubmit()}
                    readOnly={submitLoading}
                    disabled={selectedCustomer?.isEditable === false}
                  >
                    {submitLoading ? (
                      <div id="loading_both">
                        <i id="spinner" className="fa fa-spinner fa-spin"></i>
                      </div>
                    ) : vkPlanningAllInOneNew?.isJahresVkExist === true ? (
                      "Speichern"
                    ) : (
                      "Einreichen"
                    )}
                  </button>
                </div>
                <div>
                  <button
                    type="button"
                    className="btn btn-danger vkplanning-submitBtn"
                    onClick={getDelete}
                    readOnly={deleteLoading}
                    disabled={selectedCustomer?.isEditable === false}
                  >
                    {deleteLoading ? (
                      <div id="loading_both">
                        <i id="spinner" className="fa fa-spinner fa-spin"></i>{" "}
                      </div>
                    ) : (
                      "Löschen"
                    )}
                  </button>
                </div>
              </Col>
            </Row>
          </div>

          {showSoldToDecisionModal && (
            <div className="mandatory-modal-actions-vkplanning">
              <label>
                <input
                  type="radio"
                  name="zeroOnly"
                  value="zeroOnly"
                  checked={soldToDecision === "zeroOnly"}
                  onChange={(e) => setSoldToDecision(e.target.value)}
                  style={{ marginRight: "5px" }}
                />
                Initialize the old customer {selectedCustomer?.soldTo}/
                {selectedCustomer?.shipTo} with a 0 plan
              </label>

              <label>
                <input
                  type="radio"
                  name="zeroAndNewEntry"
                  value="zeroAndNewEntry"
                  checked={soldToDecision === "zeroAndNewEntry"}
                  onChange={(e) => setSoldToDecision(e.target.value)}
                  style={{ marginRight: "5px" }}
                  defaultChecked
                />
                Initialize the old customer {selectedCustomer?.soldTo}/
                {selectedCustomer?.shipTo} with a 0 plan and move the plan to
                the new customer {selectedCustomer?.newSoldTo}/
                {selectedCustomer?.newShipTo}
              </label>
            </div>
          )}

          <div className="planning_container">
            <Row className="w-100 d-flex justify-content-center">
              <Col className="vkPlanning-grid-box for_1st_column">
                <Form
                  className="grid_1_row"
                  onSubmit={(e) => e.preventDefault()}
                >
                  <Form.Group className="planningInputMain1">
                    <Form.Label column className="planningInputMain1_text">
                      Eingangskalkulation(Aufschlag)
                    </Form.Label>
                    <div className="planningInputMain1_input_main">
                      {selectedCustomer?.isEditable === false ? (
                        <div className="lockIcon">
                          <i className="fa-solid fa-lock"></i>
                        </div>
                      ) : null}
                      <input
                        className="planningInputMain1_input"
                        type="text"
                        name="eingangskalkulationAufschlag"
                        value={
                          formatGermanFixedBy2(
                            vkPlanningAllInOneNew?.HDP
                              ?.eingangskalkulationAufschlag
                          ) || ""
                        }
                        // value={
                        //   formatGermanFixedBy2(
                        //     (Number(
                        //       vkPlanningAllInOneNew?.PARTP?.[0]
                        //         ?.estimatedCalc
                        //     ) +
                        //       Number(
                        //         vkPlanningAllInOneNew?.PARTP?.[1]
                        //           ?.estimatedCalc
                        //       )) /
                        //       2
                        //   ) || ""
                        // }
                        // onChange={(e) => handleChangeForAll("HDP", e)}
                        // onBlur={(e) => handleBlurForAll("HDP", e)}
                        placeholder="Enter Value"
                        style={{
                          border: "1px solid rgb(247, 246, 215)",
                          background: "rgb(247, 246, 215)",
                        }}
                        autoComplete="off"
                        readOnly
                        // readOnly={selectedCustomer?.isEditable === false}
                      />
                    </div>
                  </Form.Group>
                </Form>
              </Col>
              <Col className="vkPlanning-grid-box">
                <Form
                  className="grid_1_row"
                  onSubmit={(e) => e.preventDefault()}
                >
                  <Form.Group className="planningInputMain1">
                    <Form.Label
                      column
                      md={5}
                      className="planningInputMain2_text"
                    >
                      Nach Rabatt
                    </Form.Label>
                    <div className="planningInputMain1_input_main">
                      {selectedCustomer?.isEditable === false ? (
                        <div className="lockIcon">
                          <i className="fa-solid fa-lock"></i>
                        </div>
                      ) : null}
                      <input
                        className="planningInputMain1_input"
                        type="text"
                        name="nachRabatt1"
                        value={
                          formatGermanFixedBy2(
                            vkPlanningAllInOneNew?.HDP?.nachRabatt1
                          ) || ""
                        }
                        // onChange={(e) => handleChangeForAll("HDP", e)}
                        // onBlur={(e) => handleBlurForAll("HDP", e)}
                        placeholder="Enter Value"
                        style={{
                          border: "1px solid rgb(247, 246, 215)",
                          background: "rgb(247, 246, 215)",
                        }}
                        autoComplete="off"
                        readOnly
                        // readOnly={selectedCustomer?.isEditable === false}
                      />
                    </div>
                  </Form.Group>
                </Form>
              </Col>
              <Col
                className="vkPlanning-grid-box"
                style={{ border: "2px solid green", borderRadius: ".2rem" }}
              >
                <Form
                  className="grid_1_row"
                  onSubmit={(e) => e.preventDefault()}
                >
                  <Form.Group className="planningInputMain1">
                    <Form.Label
                      column
                      md={5}
                      className="planningInputMain2_text"
                    >
                      Jahres-VK
                    </Form.Label>
                    <div className="planningInputMain1_input_main">
                      {selectedCustomer?.isEditable === false ? (
                        <div className="lockIcon">
                          <i className="fa-solid fa-lock"></i>
                        </div>
                      ) : null}
                      <input
                        name="jahresVK"
                        className="planningInputMain1_input"
                        type="text"
                        placeholder="Enter Value"
                        value={formatGermanInputForDecimal(
                          Math.round(vkPlanningAllInOneNew?.HDP?.jahresVK)
                        )}
                        onChange={(e) => handleChangeForAll("HDP", e)}
                        onBlur={(e) => handleBlurForAll("HDP", e)}
                        style={{
                          border: "1px solid rgb(212, 236, 251)",
                          background: "rgb(212, 236, 251)",
                        }}
                        autoComplete="off"
                        readOnly={selectedCustomer?.isEditable === false}
                      />
                    </div>
                  </Form.Group>
                </Form>
              </Col>
              <Col className="vkPlanning-grid-box">
                <Form
                  className="grid_1_row"
                  onSubmit={(e) => e.preventDefault()}
                >
                  <Form.Group className="planningInputMain1">
                    <Form.Label
                      column
                      md={4}
                      className="planningInputMain2_text"
                    >
                      LUG
                    </Form.Label>
                    <div className="planningInputMain1_input_main">
                      {selectedCustomer?.isEditable === false ? (
                        <div className="lockIcon">
                          <i className="fa-solid fa-lock"></i>
                        </div>
                      ) : null}
                      <input
                        className="planningInputMain1_input"
                        type="text"
                        name="lug"
                        value={
                          formatGermanFixedBy2(
                            (Number(
                              vkPlanningAllInOneNew?.PARTP?.[0]?.lugPlan
                            ) +
                              Number(
                                vkPlanningAllInOneNew?.PARTP?.[1]?.lugPlan
                              )) /
                              2
                          ) || ""
                        }
                        // value={
                        //   formatGermanFixedBy2(vkPlanningAllInOneNew?.HDP?.lugPlan) || ""
                        // }
                        // onChange={(e) => handleChangeForAll("HDP", e)}
                        // onBlur={(e) => handleBlurForAll("HDP", e)}
                        style={{
                          border: "1px solid rgb(247, 246, 215)",
                          background: "rgb(247, 246, 215)",
                        }}
                        autoComplete="off"
                        readOnly
                        // readOnly={selectedCustomer?.isEditable === false}
                      />
                    </div>
                  </Form.Group>
                </Form>
              </Col>
              <Col className="vkPlanning-grid-box">
                <Form
                  className="grid_1_row"
                  onSubmit={(e) => e.preventDefault()}
                >
                  <Form.Group className="planningInputMain1">
                    <Form.Label
                      column
                      md={4}
                      className="planningInputMain2_text"
                    >
                      Shopfläche in m²
                    </Form.Label>
                    <div className="planningInputMain1_input_main">
                      <input
                        className="planningInputMain1_input"
                        type="text"
                        value={
                          formatGermanInputForDecimal(
                            vkPlanningAllInOneNew?.ssqr || ""
                          ) || ""
                        }
                        style={{
                          border: "1px solid rgb(247, 246, 215)",
                          background: "rgb(247, 246, 215)",
                        }}
                        autoComplete="off"
                        readOnly
                        // readOnly={selectedCustomer?.isEditable === true || readOnly}
                      />
                    </div>
                  </Form.Group>
                </Form>
              </Col>
            </Row>
            <Row className="w-100 d-flex justify-content-center">
              <Col className="vkPlanning-grid-box for_1st_column">
                <Form
                  className="grid_1_row"
                  onSubmit={(e) => e.preventDefault()}
                >
                  <Form.Group className="planningInputMain1">
                    <Form.Label column className="planningInputMain1_text">
                      Eingangskalkulation(Abschlag)
                    </Form.Label>
                    <div className="planningInputMain1_input_main">
                      {selectedCustomer?.isEditable === false ? (
                        <div className="lockIcon">
                          <i className="fa-solid fa-lock"></i>
                        </div>
                      ) : null}
                      <input
                        className="planningInputMain1_input"
                        type="text"
                        name="eingangskalkulationAbschlag"
                        placeholder="Enter Value"
                        value={
                          formatGermanFixedBy2(
                            vkPlanningAllInOneNew?.HDP
                              ?.eingangskalkulationAbschlag
                          ) || ""
                        }
                        // value={
                        //   formatGermanFixedBy2(
                        //     (Number(
                        //       vkPlanningAllInOneNew?.PARTP?.[0]
                        //         ?.estimatedCalcDisc
                        //     ) +
                        //       Number(
                        //         vkPlanningAllInOneNew?.PARTP?.[1]
                        //           ?.estimatedCalcDisc
                        //       )) /
                        //       2
                        //   ) || ""
                        // }
                        // onChange={(e) => handleChangeForAll("HDP", e)}
                        // onBlur={(e) => handleBlurForAll("HDP", e)}
                        style={{
                          border: "1px solid rgb(247, 246, 215)",
                          background: "rgb(247, 246, 215)",
                        }}
                        autoComplete="off"
                        readOnly
                        // readOnly={selectedCustomer?.isEditable === false}
                      />
                    </div>
                  </Form.Group>
                </Form>
              </Col>
              <Col className="vkPlanning-grid-box">
                <Form
                  className="grid_1_row"
                  onSubmit={(e) => e.preventDefault()}
                >
                  <Form.Group className="planningInputMain1">
                    <Form.Label
                      column
                      md={5}
                      className="planningInputMain2_text"
                    >
                      Nach Rabatt
                    </Form.Label>
                    <div className="planningInputMain1_input_main">
                      {selectedCustomer?.isEditable === false ? (
                        <div className="lockIcon">
                          <i className="fa-solid fa-lock"></i>
                        </div>
                      ) : null}
                      <input
                        className="planningInputMain1_input"
                        type="text"
                        placeholder="Enter Value"
                        name="nachRabatt2"
                        value={
                          formatGermanFixedBy2(
                            vkPlanningAllInOneNew?.HDP?.nachRabatt2
                          ) || ""
                        }
                        // onChange={(e) => handleChangeForAll("HDP", e)}
                        // onBlur={(e) => handleBlurForAll("HDP", e)}
                        style={{
                          border: "1px solid rgb(247, 246, 215)",
                          background: "rgb(247, 246, 215)",
                        }}
                        autoComplete="off"
                        readOnly
                        // readOnly={selectedCustomer?.isEditable === false}
                      />
                    </div>
                  </Form.Group>
                </Form>
              </Col>
              <Col className="vkPlanning-grid-box">
                <Form
                  className="grid_1_row"
                  onSubmit={(e) => e.preventDefault()}
                >
                  <Form.Group className="planningInputMain1">
                    <Form.Label
                      column
                      md={5}
                      className="planningInputMain2_text"
                    >
                      Jahres-EK
                    </Form.Label>
                    <div className="planningInputMain1_input_main">
                      {selectedCustomer?.isEditable === false ? (
                        <div className="lockIcon">
                          <i className="fa-solid fa-lock"></i>
                        </div>
                      ) : null}
                      <input
                        name="jahresEK"
                        className="planningInputMain1_input"
                        type="text"
                        placeholder="Enter Value"
                        value={
                          formatGermanInputForDecimal(
                            Math.round(vkPlanningAllInOneNew?.HDP?.jahresEK)
                          ) || ""
                        }
                        // onChange={(e) => handleChangeForAll("HDP", e)}
                        // onBlur={(e) => handleBlurForAll("HDP", e)}
                        style={{
                          border: "1px solid rgb(247, 246, 215)",
                          background: "rgb(247, 246, 215)",
                        }}
                        autoComplete="off"
                        // readOnly
                        readOnly
                        // disabled
                      />
                    </div>
                  </Form.Group>
                </Form>
              </Col>

              <Col className="vkPlanning-grid-box">
                <Form
                  className="grid_1_row"
                  onSubmit={(e) => e.preventDefault()}
                >
                  <Form.Group className="planningInputMain1">
                    <Form.Label
                      column
                      md={5}
                      className="planningInputMain2_text"
                    >
                      LUG Plan
                    </Form.Label>
                    <div className="planningInputMain1_input_main">
                      {selectedCustomer?.isEditable === false ? (
                        <div className="lockIcon">
                          <i className="fa-solid fa-lock"></i>
                        </div>
                      ) : null}
                      <input
                        className="planningInputMain1_input"
                        type="text"
                        placeholder="Enter Value"
                        name="lugPlan"
                        value={
                          formatGermanFixedBy2(
                            vkPlanningAllInOneNew?.HDP?.lugPlan,
                            2
                          ) || ""
                        }
                        // onChange={(e) => handleChangeForAll("HDP", e)}
                        // onBlur={(e) => handleBlurForAll("HDP", e)}
                        style={{
                          border: "1px solid rgb(247, 246, 215)",
                          background: "rgb(247, 246, 215)",
                        }}
                        autoComplete="off"
                        // readOnly={selectedCustomer?.isEditable === false}
                        readOnly
                      />
                    </div>
                  </Form.Group>
                </Form>
              </Col>
              <Col className="vkPlanning-grid-box">
                <Form
                  className="grid_1_row"
                  onSubmit={(e) => e.preventDefault()}
                >
                  <Form.Group className="planningInputMain1">
                    <Form.Label
                      column
                      md={4}
                      className="planningInputMain2_text"
                    >
                      Umsatz pro m²
                    </Form.Label>
                    <div className="planningInputMain1_input_main">
                      <input
                        className="planningInputMain1_input"
                        type="text"
                        value={
                          formatGermanInputForDecimal(
                            Math.round(
                              Number(
                                vkPlanningAllInOneNew?.HDP?.jahresVK || 0
                              ) / Number(vkPlanningAllInOneNew?.ssqr || 0)
                            )
                          ) ?? ""
                        }
                        style={{
                          border: "1px solid rgb(247, 246, 215)",
                          background: "rgb(247, 246, 215)",
                        }}
                        autoComplete="off"
                        readOnly
                        // readOnly={selectedCustomer?.isEditable === true || readOnly}
                      />
                    </div>
                  </Form.Group>
                </Form>
              </Col>
            </Row>
            <Row className="w-100 d-flex justify-content-center">
              <Col className="vkPlanning-grid-box for_1st_column">
                <Form
                  className="grid_1_row"
                  onSubmit={(e) => e.preventDefault()}
                >
                  <Form.Group className="planningInputMain1">
                    <Form.Label column className="planningInputMain1_text">
                      Ausgangskalkulation(Aufschlag)
                    </Form.Label>
                    <div className="planningInputMain1_input_main">
                      {selectedCustomer?.isEditable === false ? (
                        <div className="lockIcon">
                          <i className="fa-solid fa-lock"></i>
                        </div>
                      ) : null}
                      <input
                        className="planningInputMain1_input"
                        type="text"
                        name="ausgangskalkulationAufschlag"
                        placeholder="Enter Value"
                        value={
                          formatGermanFixedBy2(
                            vkPlanningAllInOneNew?.HDP
                              ?.ausgangskalkulationAufschlag
                          ) || ""
                        }
                        // value={
                        //   formatGermanFixedBy2(
                        //     (Number(
                        //       vkPlanningAllInOneNew?.PARTP?.[0]?.outgoingCalc
                        //     ) +
                        //       Number(
                        //         vkPlanningAllInOneNew?.PARTP?.[1]
                        //           ?.outgoingCalc
                        //       )) /
                        //       2
                        //   ) || ""
                        // }
                        // onChange={(e) => handleChangeForAll("HDP", e)}
                        // onBlur={(e) => handleBlurForAll("HDP", e)}
                        style={{
                          border: "1px solid rgb(247, 246, 215)",
                          background: "rgb(247, 246, 215)",
                        }}
                        autoComplete="off"
                        readOnly
                        // readOnly={selectedCustomer?.isEditable === false}
                      />
                    </div>
                  </Form.Group>
                </Form>
              </Col>
              <Col className="vkPlanning-grid-box">
                <Form
                  className="grid_1_row"
                  onSubmit={(e) => e.preventDefault()}
                >
                  <Form.Group className="planningInputMain1">
                    <Form.Label
                      column
                      md={5}
                      className="planningInputMain2_text"
                    >
                      Nach Rabatt
                    </Form.Label>
                    <div className="planningInputMain1_input_main">
                      {selectedCustomer?.isEditable === false ? (
                        <div className="lockIcon">
                          <i className="fa-solid fa-lock"></i>
                        </div>
                      ) : null}
                      <input
                        className="planningInputMain1_input"
                        type="text"
                        placeholder="Enter Value"
                        name="nachRabatt3"
                        value={
                          formatGermanFixedBy2(
                            vkPlanningAllInOneNew?.HDP?.nachRabatt3
                          ) || ""
                        }
                        // onChange={(e) => handleChangeForAll("HDP", e)}
                        // onBlur={(e) => handleBlurForAll("HDP", e)}
                        style={{
                          border: "1px solid rgb(247, 246, 215)",
                          background: "rgb(247, 246, 215)",
                        }}
                        autoComplete="off"
                        readOnly
                        // readOnly={selectedCustomer?.isEditable === false}
                      />
                    </div>
                  </Form.Group>
                </Form>
              </Col>

              <Col className="vkPlanning-grid-box">
                <Form
                  className="grid_1_row"
                  onSubmit={(e) => e.preventDefault()}
                >
                  <Form.Group className="planningInputMain1">
                    <Form.Label
                      column
                      md={5}
                      className="planningInputMain2_text"
                    >
                      Bestand Ø
                    </Form.Label>
                    <div className="planningInputMain1_input_main">
                      {selectedCustomer?.isEditable === false ? (
                        <div className="lockIcon">
                          <i className="fa-solid fa-lock"></i>
                        </div>
                      ) : null}
                      <input
                        className="planningInputMain1_input"
                        type="text"
                        placeholder="Enter Value"
                        name="bestandAvg"
                        value={
                          formatGermanInputForDecimal(
                            Math.round(
                              Number(
                                vkPlanningAllInOneNew?.PARTP?.[0]
                                  ?.planStockAvail || 0
                              ) +
                                Number(
                                  vkPlanningAllInOneNew?.PARTP?.[1]
                                    ?.planStockAvail || 0
                                )
                            )
                          ) || ""
                        }
                        // onChange={(e) => handleChangeForAll("HDP", e)}
                        // onBlur={(e) => handleBlurForAll("HDP", e)}
                        style={{
                          border: "1px solid rgb(247, 246, 215)",
                          background: "rgb(247, 246, 215)",
                        }}
                        autoComplete="off"
                        readOnly
                        // readOnly={selectedCustomer?.isEditable === false}
                      />
                    </div>
                  </Form.Group>
                </Form>
              </Col>
              <Col className="vkPlanning-grid-box">
                <Form
                  className="grid_1_row"
                  onSubmit={(e) => e.preventDefault()}
                >
                  <Form.Group className="planningInputMain1">
                    <Form.Label
                      column
                      md={5}
                      className="planningInputMain2_text"
                    >
                      Abschrift %
                    </Form.Label>
                    <div className="planningInputMain1_input_main">
                      {selectedCustomer?.isEditable === false ? (
                        <div className="lockIcon">
                          <i className="fa-solid fa-lock"></i>
                        </div>
                      ) : null}
                      <input
                        className="planningInputMain1_input"
                        type="text"
                        name="abschriftPercent"
                        placeholder="Enter Value"
                        // value={
                        //   formatGermanFixedBy2(
                        //     vkPlanningAllInOneNew?.HDP?.abschriftPercent
                        //   ) || ""
                        // }
                        value={
                          formatGermanFixedBy2(
                            (Number(
                              vkPlanningAllInOneNew?.PARTP?.[0]?.percred
                            ) +
                              Number(
                                vkPlanningAllInOneNew?.PARTP?.[1]?.percred
                              )) /
                              2
                          ) || ""
                        }
                        // onChange={(e) => handleChangeForAll("HDP", e)}
                        // onBlur={(e) => handleBlurForAll("HDP", e)}
                        style={{
                          border: "1px solid rgb(247, 246, 215)",
                          background: "rgb(247, 246, 215)",
                        }}
                        autoComplete="off"
                        readOnly
                        // readOnly={selectedCustomer?.isEditable === false}
                      />
                    </div>
                  </Form.Group>
                </Form>
              </Col>
              <Col className="vkPlanning-grid-box">
                <Form
                  className="grid_1_row"
                  onSubmit={(e) => e.preventDefault()}
                >
                  <Form.Group className="planningInputMain1">
                    <Form.Label
                      column
                      md={5}
                      className="planningInputMain2_text"
                    >
                      Durchschnitts EK
                    </Form.Label>
                    <div className="planningInputMain1_input_main">
                      {selectedCustomer?.isEditable === false ? (
                        <div className="lockIcon">
                          <i className="fa-solid fa-lock"></i>
                        </div>
                      ) : null}
                      <input
                        className="planningInputMain1_input"
                        type="text"
                        placeholder="Enter Value"
                        name="durchschnittsEK"
                        value={
                          formatGermanInputForDecimal(
                            vkPlanningAllInOneNew?.HDP?.durchschnittsEK || ""
                          ) || ""
                        }
                        onChange={(e) => handleChangeForAll("HDP", e)}
                        onBlur={(e) => handleBlurForAll("HDP", e)}
                        inputMode="decimal"
                        style={{
                          border: "1px solid rgb(212, 236, 251)",
                          background: "rgb(212, 236, 251)",
                        }}
                        autoComplete="off"
                        readOnly={selectedCustomer?.isEditable === false}
                      />
                    </div>
                  </Form.Group>
                </Form>
              </Col>
            </Row>
            <Row className="w-100 d-flex justify-content-center">
              <Col className="vkPlanning-grid-box for_1st_column">
                <Form
                  className="grid_1_row"
                  onSubmit={(e) => e.preventDefault()}
                >
                  <Form.Group className="planningInputMain1">
                    <Form.Label column className="planningInputMain1_text">
                      Ausgangskalkulation(Abschlag)
                    </Form.Label>
                    <div className="planningInputMain1_input_main">
                      {selectedCustomer?.isEditable === false ? (
                        <div className="lockIcon">
                          <i className="fa-solid fa-lock"></i>
                        </div>
                      ) : null}
                      <input
                        className="planningInputMain1_input"
                        type="text"
                        placeholder="Enter Value"
                        name="ausgangskalkulationAbschlag"
                        value={
                          formatGermanFixedBy2(
                            vkPlanningAllInOneNew?.HDP
                              ?.ausgangskalkulationAbschlag
                          ) || ""
                        }
                        // value={
                        //   formatGermanFixedBy2(
                        //     (Number(
                        //       vkPlanningAllInOneNew?.PARTP?.[0]
                        //         ?.outgoingCalcDisc
                        //     ) +
                        //       Number(
                        //         vkPlanningAllInOneNew?.PARTP?.[1]
                        //           ?.outgoingCalcDisc
                        //       )) /
                        //       2
                        //   ) || ""
                        // }
                        // onChange={(e) => handleChangeForAll("HDP", e)}
                        // onBlur={(e) => handleBlurForAll("HDP", e)}
                        style={{
                          border: "1px solid rgb(247, 246, 215)",
                          background: "rgb(247, 246, 215)",
                        }}
                        autoComplete="off"
                        readOnly={selectedCustomer?.isEditable === false}
                      />
                    </div>
                  </Form.Group>
                </Form>
              </Col>
              <Col className="vkPlanning-grid-box">
                <Form
                  className="grid_1_row"
                  onSubmit={(e) => e.preventDefault()}
                >
                  <Form.Group className="planningInputMain1">
                    <Form.Label
                      column
                      md={5}
                      className="planningInputMain2_text"
                    >
                      Nach Rabatt
                    </Form.Label>
                    <div className="planningInputMain1_input_main">
                      {selectedCustomer?.isEditable === false ? (
                        <div className="lockIcon">
                          <i className="fa-solid fa-lock"></i>
                        </div>
                      ) : null}
                      <input
                        className="planningInputMain1_input"
                        type="text"
                        placeholder="Enter Value"
                        name="nachRabatt4"
                        value={
                          formatGermanFixedBy2(
                            vkPlanningAllInOneNew?.HDP?.nachRabatt4
                          ) || ""
                        }
                        // onChange={(e) => handleChangeForAll("HDP", e)}
                        // onBlur={(e) => handleBlurForAll("HDP", e)}
                        style={{
                          border: "1px solid rgb(247, 246, 215)",
                          background: "rgb(247, 246, 215)",
                        }}
                        autoComplete="off"
                        readOnly
                        // readOnly={selectedCustomer?.isEditable === false}
                      />
                    </div>
                  </Form.Group>
                </Form>
              </Col>
              <Col className="vkPlanning-grid-box">
                <Form
                  className="grid_1_row"
                  onSubmit={(e) => e.preventDefault()}
                >
                  <Form.Group className="planningInputMain1">
                    <Form.Label
                      column
                      md={5}
                      className="planningInputMain2_text"
                    >
                      Rabatt %
                    </Form.Label>
                    <div className="planningInputMain1_input_main">
                      {selectedCustomer?.isEditable === false ? (
                        <div className="lockIcon">
                          <i className="fa-solid fa-lock"></i>
                        </div>
                      ) : null}
                      <input
                        className="planningInputMain1_input"
                        type="text"
                        placeholder="Enter Value"
                        name="DIPE"
                        value={
                          formatGermanFixedBy2(
                            vkPlanningAllInOneNew?.HDP?.DIPE,
                            2
                          ) || ""
                        }
                        onChange={(e) => handleChangeForAll("HDP", e)}
                        onBlur={(e) => handleBlurForAll("HDP", e)}
                        style={{
                          border: "1px solid rgb(212, 236, 251)",
                          background: "rgb(212, 236, 251)",
                        }}
                        autoComplete="off"
                        readOnly={selectedCustomer?.isEditable === false}
                      />
                    </div>
                  </Form.Group>
                </Form>
              </Col>
              <Col className="vkPlanning-grid-box">
                <Form
                  className="grid_1_row"
                  onSubmit={(e) => e.preventDefault()}
                >
                  <Form.Group className="planningInputMain1">
                    <Form.Label
                      column
                      md={5}
                      className="planningInputMain2_text"
                    >
                      Abschrift absolut
                    </Form.Label>
                    <div className="planningInputMain1_input_main">
                      {selectedCustomer?.isEditable === false ? (
                        <div className="lockIcon">
                          <i className="fa-solid fa-lock"></i>
                        </div>
                      ) : null}
                      <input
                        className="planningInputMain1_input"
                        type="text"
                        placeholder="Enter Value"
                        name="abschriftAbsolut"
                        value={
                          formatGermanFixedBy2(
                            vkPlanningAllInOneNew?.HDP?.abschriftAbsolut,
                            2,
                            2
                          ) || ""
                        }
                        // onChange={(e) => handleChangeForAll("HDP", e)}
                        // onBlur={(e) => handleBlurForAll("HDP", e)}
                        style={{
                          border: "1px solid rgb(247, 246, 215)",
                          background: "rgb(247, 246, 215)",
                        }}
                        autoComplete="off"
                        // readOnly={selectedCustomer?.isEditable === false}
                        readOnly
                      />
                    </div>
                  </Form.Group>
                </Form>
              </Col>
              <Col
                className="vkPlanning-grid-box"
                style={{ border: "none" }}
              ></Col>
            </Row>
          </div>
          {/* planningData */}
          <div className="planningData_row">
            <PlanningWes1
              singleApiData={singleApiData}
              getValueInput={getValue}
              vkPlanningAllInOneNew={vkPlanningAllInOneNew}
              setVkPlanningAllInOneNew={setVkPlanningAllInOneNew}
              handleChangeWES={handleChangeForAll}
              handleBlurWES={handleBlurForAll}
              copyTemplate={copyTemplate}
              formatGermanInputForDecimal={formatGermanInputForDecimal}
              isEditable={selectedCustomer?.isEditable}
            />
          </div>
          {/* planningTable */}
          <div className="planning_container_table">
            <PlanningTableNew
              singleApiData={singleApiData}
              resetFlag={resetFlag}
              onResetDone={() => setResetFlag(false)}
              vkPlanningAllInOneNew={vkPlanningAllInOneNew}
              setVkPlanningAllInOneNew={setVkPlanningAllInOneNew}
              handleChangeForAll={handleChangeForAll}
              handleBlurForAll={handleBlurForAll}
              paramsData={newTemplateForAll}
              isEditable={selectedCustomer?.isEditable}
            />
          </div>
          <div className="vk-planning-last-update-div m-2">
            <Row className="vk-planning-last-updte-row">
              <Col md={12}>
                {formattedTime.length > 0 ? (
                  <div className="lastUpdate">
                    <div className="scroll-container">
                      <div className="scroll-text">{`Zuletzt aktualisiert am ${formattedTime} `}</div>
                    </div>
                  </div>
                ) : null}
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <div>
        <Footer className="footer" />
      </div>
    </div>
  );
};

export default Planning;
